import { useMediaQuery } from "@vueuse/core";
import { computed } from "vue";

/**
 * Which layout the screen is in.
 *
 * Named after intent rather than pixels, so a component asks "am I on a phone"
 * instead of restating a breakpoint it does not own. The three bands match the
 * ones the front spec declares per screen.
 */
export function useBreakpoint() {
	const isMobile = useMediaQuery("(max-width: 767px)");
	const isTablet = useMediaQuery("(min-width: 768px) and (max-width: 1279px)");
	const isDesktop = useMediaQuery("(min-width: 1280px)");

	/**
	 * Whether dragging should be offered at all.
	 *
	 * Deliberately false on touch: dragging a card between columns on a small
	 * screen misses more often than it lands, and a stage picker is both faster and
	 * less annoying (F-ADR-011).
	 */
	const canDrag = computed(() => !isMobile.value);

	return { isMobile, isTablet, isDesktop, canDrag };
}
